export default "__VITE_ASSET__bn0crofB__"